<div class="theme-preloader" [ngClass]="{ hidden: transactionLoaded() && themeService.currentTheme()  }">
  <img src="assets/images/logoanimation-small.svg" alt="Loading..." />
    <div class="loader-text" [class.visible]="!transactionLoaded() && dataReady">
      <h3>{{ 'LOADER.Heading' | translate }}</h3>
      <p>{{ 'LOADER.Subheading' | translate }}</p>
      <span>{{ 'LOADER.Hint' | translate }}</span>
    </div>
</div>

@if (dataReady && splashReady()) {
  <div id="root" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="router">
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <app-splash-screen></app-splash-screen>
}